export default "__VITE_ASSET__XiloxZEb__"